/* eslint-disable react/no-array-index-key */
import React from "react";
import he from "he";

export const decodeAndSplitByBr = (value?: string): React.ReactNode[] => {
    const decoded = he.decode(value || "");
    const parts = decoded.split(/<br\s*\/?>/g);

    return parts.map((part, index, myArray) => (
        <React.Fragment key={index}>
            {part}
            {index < myArray.length - 1 && <br />}
        </React.Fragment>
    ));
};
